import { COUNTRY_LIST, REGION_LIST } from '@cyberint/common-utils';
import { Flag } from '../lib/Flag';

export const InputHeights = {
  DYNAMIC: 'DYNAMIC',
  LARGE: 'LARGE',
  MEDIUM: 'MEDIUM',
  SMALL: 'SMALL',
  TINY: 'TINY'
};

export const Orientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};

export const heightToPixel = {
  [InputHeights.DYNAMIC]: 'unset',
  [InputHeights.LARGE]: '48px',
  [InputHeights.MEDIUM]: '36px',
  [InputHeights.SMALL]: '32px',
  [InputHeights.TINY]: '24px'
};

const countryOptions = countries =>
  countries.map(country => ({
    label: country.country,
    value: country.country,
    icon: country.code ? <Flag alt={country.country} code={country.code} /> : null,
    mappedValue: country.code
  }));

const mapRegionsToOptions = () =>
  REGION_LIST.map(region => {
    const regionCountries = countryOptions(COUNTRY_LIST.filter(c => c.region === region));
    return { label: region, value: region, children: regionCountries };
  });

export const REGION_COUNTRIES_OPTIONS = mapRegionsToOptions();
export const COUNTRIES_OPTIONS = countryOptions(COUNTRY_LIST);
export const REGIONS_OPTIONS = REGION_LIST.map(region => ({
  label: region,
  value: region === 'Oceania' ? 'Australia and New Zealand' : region
}));
